module.exports = __webpack_public_path__ + "static/media/aeish.739c8ecb.jpeg";